/**
 * Validation function to check if the given string
 * can be a valid Credit card Holder name.
 *
 * https://redmine.exozet.com/issues/138552
 * @param str
 * @returns {boolean}
 */
export const isValidCardHolderName = (str) => {
    return /^[A-Z,a-z,+,0-9, ,-,.,',`,´]{2,45}$/.test(str)
}



// WEBPACK FOOTER //
// ./src/utils/isValidCardHolderName.js